import { computed } from '@vue/composition-api'
import { chain, map, each } from 'lodash'
import { BusinessResultMoneyDetailListHeaders } from '@/utils/constants/table-headers'

export default ({ moneyIncomeDetailList, moneySpendingDetailList, realMoneyProfits }) => {
  const items = computed(() => {
    const moneyProfitList = map(realMoneyProfits.value, o => {
      const { date, amount } = o.attributes

      return { time: date, realMoneyProfit: amount }
    })

    return chain([...moneyIncomeDetailList.value, ...moneySpendingDetailList.value, ...moneyProfitList])
      .groupBy('time')
      .map((triplet, _key) => {
        const o = { ...triplet[0], ...triplet[1], ...(triplet[2] || {}) }
        const income = Number(o.cashAmount) + Number(o.balanceReceivableAmount) + Number(o.benefitAmount)
        const spending = Number(o.castEarningAmount) + Number(o.waiterEarningAmount) + Number(o.allianceEarningAmount) + Number(o.expenseAmount)
        const profit = income - spending
        const diff = o.realMoneyProfit ? o.realMoneyProfit - profit : null

        return {
          ...o,
          income,
          spending,
          profit,
          realMoneyProfit: o.realMoneyProfit,
          diff,
        }
      })
      .value()
  })

  const buildXlsxData = () => {
    return map(items.value, o => {
      const data = {}

      each(BusinessResultMoneyDetailListHeaders, h => {
        data[h.text] = Number.isNaN(Number(o[h.value]))
          ? o[h.value]
          : Number(o[h.value])
      })

      return data
    })
  }

  return {
    items,
    buildXlsxData,
  }
}
